var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.2,
    viewBox: "0 0 20 15.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.267-15.2H1.733A1.676,1.676,0,0,0,.5-14.7,1.676,1.676,0,0,0,0-13.467V-1.733A1.676,1.676,0,0,0,.5-.5,1.676,1.676,0,0,0,1.733,0H18.267A1.676,1.676,0,0,0,19.5-.5,1.676,1.676,0,0,0,20-1.733V-13.467a1.676,1.676,0,0,0-.5-1.233A1.676,1.676,0,0,0,18.267-15.2ZM18-14.067l-7.933,8L2-14.067ZM1.2-2V-13.2L6.8-7.6Zm.8.867L7.667-6.8,9.6-4.867a.605.605,0,0,0,.433.2.605.605,0,0,0,.433-.2L12.4-6.8,18-1.133ZM18.8-2,13.2-7.6l5.6-5.6Z",
    transform: "translate(0 15.2)",
    fill: "#c38f51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.5e38ea6e9010002e2d4212efb6f37906.svg";
export { ForwardRef as ReactComponent };